export const MAX_DRIVERS_COUNT_DEFAULT = 0;
